module.exports = __webpack_public_path__ + "static/media/ql-icon-music.6922060f.svg";